import React from 'react';
import { useAdminUsersQuery } from 'api';
import { Col, Form, FormModal, Row, Select } from 'components';
import { ManagementRoleMapping } from 'models/Manager';
import { useManagementEditModal } from './useManagementEditModal';

export interface IManagementEditModal {
  modalState: boolean;
  onModalStateChange: () => void;
}

export const ManagementEditModal = (props: IManagementEditModal) => {
  const { modalState, onModalStateChange } = props;
  const { data: userData } = useAdminUsersQuery();
  const { onFinish, isLoading, form, onCancel, handleManagerChange } = useManagementEditModal({
    onModalStateChange,
    modalState,
  });
  return (
    <FormModal
      form={form}
      title={'Update Client Management'}
      width={680}
      okText={'Save'}
      open={modalState}
      isLoading={isLoading}
      onCancel={onCancel}
      onSubmit={onFinish}
    >
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Form.Item label={ManagementRoleMapping.salesManager} name={'salesManagerId'}>
            <Select
              size={'large'}
              options={userData}
              onSelect={(value) => handleManagerChange(value, 'salesManagerAssistantId')}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            shouldUpdate={(prevValues: any, currentValues: any) =>
              prevValues.salesManagerId !== currentValues.salesManagerId
            }
          >
            {({ getFieldValue }) => (
              <Form.Item label={ManagementRoleMapping.salesManagerAssistant} name={'salesManagerAssistantId'}>
                <Select
                  size={'large'}
                  options={userData.map((i: { value: string; label: string }) => ({
                    ...i,
                    disabled: getFieldValue('salesManagerId') === i.value,
                  }))}
                  disabled={!getFieldValue('salesManagerId')}
                />
              </Form.Item>
            )}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label={ManagementRoleMapping.purchaseManager} name={'purchaseManagerId'}>
            <Select
              size={'large'}
              options={userData}
              onSelect={(value) => handleManagerChange(value, 'purchaseManagerAssistantId')}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            shouldUpdate={(prevValues: any, currentValues: any) =>
              prevValues.purchaseManagerId !== currentValues.purchaseManagerId
            }
          >
            {({ getFieldValue }) => (
              <Form.Item label={ManagementRoleMapping.purchaseManagerAssistant} name={'purchaseManagerAssistantId'}>
                <Select
                  size={'large'}
                  options={userData.map((i: { value: string; label: string }) => ({
                    ...i,
                    disabled: getFieldValue('purchaseManagerId') === i.value,
                  }))}
                  disabled={!getFieldValue('purchaseManagerId')}
                />
              </Form.Item>
            )}
          </Form.Item>
        </Col>
      </Row>
    </FormModal>
  );
};
